import AddSliderModal from "./addSliderModal";

export default AddSliderModal;
